// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"860":"mobileHome","953":"pcHome"}[chunkId] + "." + {"860":"f2c36466","953":"991b23e0"}[chunkId] + ".css";
};